export const environment = {
  production: false,
  apiUrl: "https://environer-uat.une.edu.au/web-api",
  webUrl: "https://environer-uat.une.edu.au/#!/out/"
};
